import type {CSSProperties, ReactNode} from 'react';
import {iconComponents, type IconProp} from './types';
import {cn} from '@/lib/utils';
import {Hint} from '@/components/app/hint';
export interface IconProps {
  icon?: IconProp | string;
  className?: string;
  spin?: boolean;
  style?: CSSProperties;
  tooltip?: ReactNode;
  id?: string;
}
export function Icon({icon, className, spin, style, tooltip, id}: IconProps) {
  const Glyph = icon ? iconComponents[icon as IconProp] : undefined;
  if (!Glyph) return null;
  const element = (
    <Glyph
      id={id}
      aria-hidden
      className={cn(
        'inline-block size-[1em] shrink-0 align-middle',
        (spin || icon === 'spinner') && 'animate-spin',
        className,
      )}
      style={style}
      fill={icon?.endsWith('-fill') ? 'currentColor' : 'none'}
    />
  );
  return tooltip ? (
    <Hint content={tooltip}>
      <span className="inline-flex">{element}</span>
    </Hint>
  ) : (
    element
  );
}
